import React from 'react';
import { useNavigate, Link, useSearchParams } from 'react-router-dom';
import './RoleSelection.css';

const RoleSelection = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const redirectTo = searchParams.get('redirect');
  const asRole = searchParams.get('as');

  const handleRoleSelect = (role) => {
    const params = new URLSearchParams({ role });
    if (redirectTo) params.set('redirect', redirectTo);
    if (asRole) params.set('as', asRole);
    navigate(`/signup?${params.toString()}`);
  };

  return (
    <div className="role-selection-page">
      <div className="role-selection-container">
        {/* Left Panel - Welcome Back */}
        <div className="role-selection-info">
          <div className="role-selection-logo">
            <Link to="/" onClick={() => localStorage.clear()}>
              <img src={window.getPublicUrl("/assets/images/Logo.png")} alt="ClearRent" className="role-selection-logo-img" />
            </Link>
          </div>
          <h1 className="role-selection-title">Welcome back</h1>
          <p className="role-selection-subtitle">
            Access your dashboard to manage properties and review tenant screenings.
          </p>
          <ul className="role-selection-features">
            <li>
              <div className="role-selection-feature-icon">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M20 6L9 17L4 12" stroke="#1A5D3A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <span>Unlimited property listings</span>
            </li>
            <li>
              <div className="role-selection-feature-icon">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M20 6L9 17L4 12" stroke="#1A5D3A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <span>Automated voice interviews & document verification</span>
            </li>
            <li>
              <div className="role-selection-feature-icon">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M20 6L9 17L4 12" stroke="#1A5D3A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <span>Automated reference checks</span>
            </li>
          </ul>
        </div>

        {/* Right Panel - Choose Role */}
        <div className="role-selection-form-section">
          <div className="role-selection-form-card">
            <h2 className="role-selection-form-title">Choose Role</h2>
            <p className="role-selection-form-subtitle">Select how you want to use ClearRent</p>
            <div className="role-selection-cards">
              <div 
                className="role-selection-card" 
                onClick={() => handleRoleSelect('landlord')}
              >
                <div className="role-selection-card-icon">
                  <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3 9L12 2L21 9V20C21 20.5304 20.7893 21.0391 20.4142 21.4142C20.0391 21.7893 19.5304 22 19 22H5C4.46957 22 3.96086 21.7893 3.58579 21.4142C3.21071 21.0391 3 20.5304 3 20V9Z" stroke="#1A5D3A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M9 22V12H15V22" stroke="#1A5D3A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
                <h3 className="role-selection-card-title">Landlord</h3>
                <p className="role-selection-card-description">
                  Manage properties and screen tenants with automated technology
                </p>
                <div className="role-selection-card-features">
                  <div className="role-selection-card-feature">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M20 6L9 17L4 12" stroke="#1A5D3A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    <span>Unlimited property listings</span>
                  </div>
                  <div className="role-selection-card-feature">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M20 6L9 17L4 12" stroke="#1A5D3A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    <span>Automated tenant screening</span>
                  </div>
                  <div className="role-selection-card-feature">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M20 6L9 17L4 12" stroke="#1A5D3A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    <span>Document verification</span>
                  </div>
                </div>
              </div>
              <div 
                className="role-selection-card" 
                onClick={() => handleRoleSelect('tenant')}
              >
                <div className="role-selection-card-icon">
                  <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21" stroke="#1A5D3A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <circle cx="12" cy="7" r="4" stroke="#1A5D3A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
                <h3 className="role-selection-card-title">Tenant</h3>
                <p className="role-selection-card-description">
                  Apply for properties and complete screening quickly and securely
                </p>
                <div className="role-selection-card-features">
                  <div className="role-selection-card-feature">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M20 6L9 17L4 12" stroke="#1A5D3A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    <span>Quick application process</span>
                  </div>
                  <div className="role-selection-card-feature">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M20 6L9 17L4 12" stroke="#1A5D3A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    <span>Secure document upload</span>
                  </div>
                  <div className="role-selection-card-feature">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M20 6L9 17L4 12" stroke="#1A5D3A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    <span>Automated verification</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RoleSelection;
